'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSide = getSide;
exports.isHoriz = isHoriz;
exports.isVert = isVert;
exports.getEdge = getEdge;
exports.getHorizPart = getHorizPart;
exports.getVertPart = getVertPart;
exports.getCentered = getCentered;
exports.getAttachment = getAttachment;
exports.getTargetAttachment = getTargetAttachment;
exports.getOffset = getOffset;
exports.getTargetOffset = getTargetOffset;

var _PlacementConstants = require('../PlacementConstants');

function getSide(placement) {
  return placement.split(' ')[0];
}

function isHoriz(direction) {
  return _PlacementConstants.PLACEMENTS_HORIZ.indexOf(direction) !== -1;
}

function isVert(direction) {
  return _PlacementConstants.PLACEMENTS_VERT.indexOf(direction) !== -1;
}

function getEdge(placement) {
  var specifiedEdge = placement.split(' ')[1];
  if (specifiedEdge) {
    return specifiedEdge;
  }

  return isHoriz(getSide(placement)) ? 'middle' : 'center';
}

function getHorizPart(placement) {
  return isHoriz(getSide(placement)) ? getSide(placement) : getEdge(placement);
}

function getVertPart(placement) {
  return isVert(getSide(placement)) ? getSide(placement) : getEdge(placement);
}

function getCentered(direction) {
  return isHoriz(direction) ? 'middle' : 'center';
}

function getAttachment(placement) {
  // Convert to 'vert horiz' format and flip both the side and the edge
  var side = _PlacementConstants.OPPOSITE_DIRECTIONS[getSide(placement)];
  var edge = _PlacementConstants.OPPOSITE_DIRECTIONS[getEdge(placement)];
  return isHoriz(side) ? edge + ' ' + side : side + ' ' + edge;
}

function getTargetAttachment(placement, center) {
  // Convert to 'vert horiz' format and either center the edge (if center=true)
  // or flip the edge (if center=false). For example, if placement is
  // "bottom right" and we aren't centering the target attachment point,
  // then we want to attach to the *left* edge of the target.
  var side = getSide(placement);
  var edge = center ? getCentered(getEdge(placement)) : _PlacementConstants.OPPOSITE_DIRECTIONS[getEdge(placement)];
  return isHoriz(side) ? edge + ' ' + side : side + ' ' + edge;
}

function getOffset(placement, distance, inset) {
  var vert = 0;
  var horiz = 0;
  switch (getSide(placement)) {
    case 'top':
      vert = distance;
      break;
    case 'right':
      horiz = -distance;
      break;
    case 'bottom':
      vert = -distance;
      break;
    case 'left':
      horiz = distance;
      break;
    default:
      break;
  }
  switch (getEdge(placement)) {
    case 'top':
      vert = -inset;
      break;
    case 'right':
      horiz = inset;
      break;
    case 'bottom':
      vert = inset;
      break;
    case 'left':
      horiz = -inset;
      break;
    default:
      break;
  }
  return vert + 'px ' + horiz + 'px';
}

function getTargetOffset(placement, inset) {
  var vert = 0;
  var horiz = 0;
  switch (getEdge(placement)) {
    case 'top':
      vert = inset;
      break;
    case 'right':
      horiz = -inset;
      break;
    case 'bottom':
      vert = -inset;
      break;
    case 'left':
      horiz = inset;
      break;
    default:
      break;
  }
  return vert + 'px ' + horiz + 'px';
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/tooltip/utils/Placement.js
// module id = 84
// module chunks = 0